(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nemi-base"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const summary = event.target.closest('.nemi-faq__item > summary, .nemi-accordion summary');
    if (!summary || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    event.preventDefault();
    const details = summary.parentElement;
    const closing = details.open && !details.dataset.closing;
    const start = details.offsetHeight;
    details.getAnimations().forEach((animation) => animation.cancel());
    if (closing) {
      details.dataset.closing = 'true';
    } else {
      delete details.dataset.closing;
      details.open = true;
    }
    const end = closing ? summary.offsetHeight + details.offsetHeight - details.clientHeight : details.offsetHeight;
    const animation = details.animate({ height: [`${start}px`, `${end}px`] }, { duration: 280, easing: 'cubic-bezier(0.2, 0, 0, 1)' });
    animation.onfinish = () => {
      if (!details.dataset.closing) return;
      details.open = false;
      delete details.dataset.closing;
    };
  });
  } catch(e) { console.error(e); }
})();

})();
